<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Announcements" subtitle="Manage the announcements displayed to all users." :readonly="$authorised('con/announcements/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" />
		<app-content-head-actions-item text="Delete" icon="delete" :danger="true" :disabled="!selected.length" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no announcements found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />
				<app-table-column text="Date" />
				<app-table-column text="Message" />
				<app-table-column />
				<app-table-column />
				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label text="Scheduled" type="danger" v-if="item.scheduled" />
					<app-table-cell-label text="Published" v-if="!item.scheduled" />
					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />
					<app-table-cell-text :text="item.text" />
					<app-table-cell-icon icon="email" :framed="true" v-tooltip="(item.email) ? 'E-mail enabled' : 'E-mail disabled'" :theme="(item.email) ? 'green' : 'faded'" />
					<app-table-cell-icon icon="modal" :framed="true" vv-tooltip="(item.email) ? 'Pop-up enabled' : 'Pop-up disabled'" :theme="(item.modal) ? 'green' : 'faded'" />

					<app-table-cell-select :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			layout: '64px 160px auto 24px 24px 24px',
			endpoint: 'convention/announcements',
			live: 'convention/announcements',
			edit: 'Convention.Announcements.Messages.Edit'
		}

	}

}

</script>

<style scoped>

</style>